"use strict";

exports.__esModule = true;
exports.App = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HasAccess = require("../../Auth/Access/HasAccess");
var _Translator = require("../../Core/Translator");
var _System = require("../../../System");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AppName = _styledComponents["default"].div.attrs({
  className: "app-name"
}).withConfig({
  displayName: "App__AppName",
  componentId: "sc-t9l5zz-0"
})(["font-size:18px;font-weight:400;color:", ";"], function (props) {
  return props.theme.LandingPageTextColor;
});
var AppLink = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs({
  className: "app-link"
}).withConfig({
  displayName: "App__AppLink",
  componentId: "sc-t9l5zz-1"
})(["text-decoration:none;&:hover{text-decoration:none;}"]);
var AppImage = _styledComponents["default"].div.attrs({
  className: "app-image"
}).withConfig({
  displayName: "App__AppImage",
  componentId: "sc-t9l5zz-2"
})(["width:85px;margin:auto;"]);
var AppWrapper = _styledComponents["default"].div.attrs({
  className: "app-wrapper"
}).withConfig({
  displayName: "App__AppWrapper",
  componentId: "sc-t9l5zz-3"
})(["text-align:center;transition:transform 0.1s ease;min-width:150px;min-height:150px;width:33.33%;justify-content:center;display:flex;align-items:center;&:hover{transform:scale(1.3);}a:hover{cursor:pointer;text-decoration:unset;color:inherit;}"]);
var App = exports.App = function App(_ref) {
  var id = _ref.id,
    defaultName = _ref.defaultName,
    icon = _ref.icon,
    screenName = _ref.screenName,
    externalUrl = _ref.externalUrl,
    permission = _ref.permission;
  var Icon = icon;
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var name = translate(id, defaultName);
  return /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
    permission: permission
  }, /*#__PURE__*/_react["default"].createElement(AppWrapper, null, screenName && /*#__PURE__*/_react["default"].createElement(AppLink, {
    to: (0, _System.getScreenPath)(screenName).replace("/:id?", "")
  }, /*#__PURE__*/_react["default"].createElement(AppImage, null, /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement(AppName, null, name)), externalUrl && /*#__PURE__*/_react["default"].createElement("a", {
    href: externalUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(AppImage, null, /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement(AppName, null, name))));
};